/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';


export const feeds = (state = defaultState.feeds, action) => {
    let nextState = Utilities.deepClone(state);

    switch (action.type) {
        case constants.FEED_SEARCH:
            if (action.status === constants.STATE_SUCCESS) {
                nextState.searchResults = action.payload;
                // if a single object is returned as the feeds payload, put it into an array like the
                // rest of the app expects
                if (nextState.searchResults.feeds && nextState.searchResults.feeds.length === undefined) {
                    nextState.searchResults.feeds = [nextState.searchResults.feeds];
                }
            } else if (action.status === constants.STATE_TXRX) {
                nextState.searchResults = {
                    feeds: [],
                    tags: []
                };
            }
            break;

        case constants.FEED_SEARCH_RESET:
            nextState.searchResults = {
                feeds: [],
                tags: []
            };
            break;

        case constants.FEED_VALIDATE:
            if (action.status === constants.STATE_SUCCESS) {
                nextState.validated.push(action.payload);
            }
            break;

        case constants.FEED_VALIDATE_RESET:
            nextState.validated = [];
            break;

        default:
            break;

    }

    return nextState;
};
